<template>
    <multiselect
            class="grid-select"
            v-model="value"
            :options="values"
            :label="valueLabel"
            :placeholder="t('Search here')"
            :preselectFirst="false"
            :trackBy="identificator"
            tagPlaceholder=""
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
            v-on:select="updateValue($event)"
            v-on:remove="updateValue(null)"
            v-on:open="loadCodeBookData()"
    >
        <template slot="noResult">
            {{ t('No results found') }}
        </template>
    </multiselect>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        },
        computed: {
            identificator() {
                return this.settings.identificator === undefined ? 'id' : this.settings.identificator;
            },
            valueLabel() {
                return this.settings.valueLabel === undefined ? 'name' : this.settings.valueLabel;
            },
            codeBook() {
                return this.settings.codeBook === undefined ? null : this.settings.codeBook;
            },
            configValues() {
                return this.settings.values === undefined ? [] : this.settings.values;
            },
            values() {
                return this.codeBook === null ? this.configValues : this.codeBookvalues;
            }
        },
        methods: {
            updateValue(value) {
                this.$emit('change', {
                    value: value === null ? null : value[this.identificator],
                    valueTo: null
                });
            },
            loadCodeBookData() {
                if (this.codeBook !== null) {
                    this.$store.dispatch('codeBook/load', this.codeBook).then(response => {
                        this.codeBookvalues = this.$store.getters['codeBook/get'](this.codeBook);
                    }).catch(error => {
                        // todo catch error ?
                    });
                }
            }
        },
        data() {
            return {
                value: null,
                codeBookvalues: [],
            }
        }
    }
</script>
<style lang="scss">
    @import 'vue-multiselect/dist/vue-multiselect.min.css';

    .grid-select {
        min-height: 31px ! important;

        .multiselect__select {
            height: 30px;
            margin-bottom: 0 ! important;
        }


        .multiselect__content-wrapper,
        .multiselect__tags {
            border-color: #ced4da;

            .multiselect__input,
            .multiselect__single {
                margin-bottom: 0 ! important;
            }
        }

        .multiselect__tags {
            min-height: 31px;
            padding-top: 4px;
            border-color: #fff;
        }

        .multiselect__placeholder {
            margin-bottom: 5px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/core/InlineDataGrid/filters/Select.vue